"use strict";
module.exports = {
    strict: true,
    abortEarly: false,
};
//# sourceMappingURL=validationOptions.js.map